"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldUpdateScroll = exports.onRouteUpdate = exports.wrapPageElement = exports.wrapRootElement = void 0;
var react_1 = __importDefault(require("react"));
var react_cookie_1 = require("react-cookie");
var Provider_1 = require("./src/theme/Provider");
var wrapRootElement = function (_a) {
    var element = _a.element;
    return react_1.default.createElement(Provider_1.WrapRootElement, { element: element });
};
exports.wrapRootElement = wrapRootElement;
// Wraps every page in a component
var wrapPageElement = function (_a) {
    var element = _a.element;
    return react_1.default.createElement(react_cookie_1.CookiesProvider, null, element);
};
exports.wrapPageElement = wrapPageElement;
var onRouteUpdate = function () {
    var _a;
    // Track page view
    if (window.Analytics !== null) {
        (_a = window.Analytics) === null || _a === void 0 ? void 0 : _a.page();
    }
};
exports.onRouteUpdate = onRouteUpdate;
var shouldUpdateScroll = function (_a) {
    var routerProps = _a.routerProps;
    var _b = (routerProps.location.state || {}).shouldUpdateScroll, shouldUpdateScroll = _b === void 0 ? true : _b;
    return shouldUpdateScroll;
};
exports.shouldUpdateScroll = shouldUpdateScroll;
